@if (isActive) {
  <topo-modal
    [isActive]="isActive"
    [backgroundCanClose]="true"
    [isCard]="true"
    (close)="close()">
    <div class="modal-header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <h5 class="mx-4 my-4">
          {{
          (configuredChannel?.uId === emptyGuid
          ? 'MANAGEMENT.COMMUNICATION-CENTER.CREATE-CHANNEL'
          : 'MANAGEMENT.COMMUNICATION-CENTER.UPDATE-CHANNEL'
          ) | translate
          }}
        </h5>
        <div
          class="dialog-close"
          (click)="close()">
          <i class="icon icon-close-X"></i>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <form>
        <div class="field">
          <div class="channel-type">{{ configuredChannel?.channelTypeDisplay }}</div>
          <div><img [src]="configuredChannel?.logoImagePath" /></div>
        </div>
        <div class="field">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.NAME' | translate }}</label>
          <div>
            <input
              class="input is-fullwidth"
              type="text"
              placeholder="{{ 'MANAGEMENT.COMMUNICATION-CENTER.NAME' | translate }}"
              [(ngModel)]="configuredChannel.name"
              name="name" />
          </div>
        </div>
        <div class="field">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.DESCRIPTION' | translate }}</label>
          <div>
            <textarea
              name="description"
              class="textarea"
              placeholder="{{ 'MANAGEMENT.DATAFEEDS.DESCRIPTION' | translate }}"
            [(ngModel)]="configuredChannel.description"></textarea>
          </div>
        </div>
        <div class="field">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.PHONE-NUMBER' | translate }}</label>
          <div
            fxLayout="column"
            fxLayoutAlign="start">
            <div>
              <input
                class="input is-fullwidth"
                type="text"
                placeholder="{{ 'MANAGEMENT.COMMUNICATION-CENTER.PHONE-NUMBER' | translate }}"
                [(ngModel)]="configuredChannel.settings.phoneNumber"
                name="phoneNumber" />
            </div>
            <div class="text is-small is-bold">
              {{ 'MANAGEMENT.COMMUNICATION-CENTER.PHONE-NUMBER-DETAILS' | translate }}
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <div
        fxLayout="row"
        fxLayoutAlign="end"
        class="mt-4 mb-4">
        <div style="margin-right: 5px">
          <button
            class="button is-secondary"
            (click)="cancelClick()">
            {{ 'MANAGEMENT.COMMUNICATION-CENTER.CANCEL' | translate }}
          </button>
        </div>
        <div>
          <button
            class="button is-primary"
            (click)="saveClick()">
            {{ 'MANAGEMENT.COMMUNICATION-CENTER.SAVE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </topo-modal>
}
